import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=41430f1d&scoped=true&lang=pug&"
import script from "./SystemError.vue?vue&type=script&lang=js&"
export * from "./SystemError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41430f1d",
  null
  
)

export default component.exports